import sessionTypes from "./types";

const DEFAULT_SESSION = sessionTypes.Dinner;

export default DEFAULT_SESSION;
